import React from "react";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import MyTextInput from "../../../app/common/form/MyTextInput";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import { closeModal } from "../../../app/common/modals/modalReducer";
import { PASSWORD_RECOVERY_EMAIL_VALIDATION_SCHEMA } from "../../../js/constants/validationSchemas";
import { Button, Label } from "semantic-ui-react";
import {
  callAPI,
  SEND_PASSWORD_RESET_EMAIL_ENDPOINT,
} from "../../../app/api/callAPI";
import Divider from "../../../app/common/components/Divider";

export default function ResetPasswordModal() {
  const dispatch = useDispatch();

  return (
    <ModalWrapper size="tiny" modalClassName="modal-ux-wrapper">
      <div style={{ padding: 26 }}>
        <h2>Reset Password</h2>
        <Divider dividerLine={"2px solid #BCE0FD"} />
        <p style={{ margin: "20px 0" }}>
          Enter your email and we'll send you a password reset link if you're
          registered with us.
        </p>
        <Formik
          initialValues={{ email: "" }}
          validationSchema={PASSWORD_RECOVERY_EMAIL_VALIDATION_SCHEMA}
          onSubmit={async (values, { setSubmitting, setErrors }) => {
            try {
              await callAPI({
                endpoint: SEND_PASSWORD_RESET_EMAIL_ENDPOINT,
                opts: {
                  body: {
                    email: values.email.toLowerCase(),
                  },
                },
              });
              setSubmitting(false);
              dispatch(closeModal());
            } catch (error) {
              setErrors({ auth: "Problem sending password reset email" });
              setSubmitting(false);
            }
          }}
        >
          {({ isSubmitting, isValid, dirty, errors }) => (
            <Form className="ui form">
              <MyTextInput
                className="form-input-field"
                name="email"
                placeholder="Email Address"
                autoComplete="off"
              />
              {errors.auth && (
                <Label
                  basic
                  color="red"
                  style={{ marginBottom: 10 }}
                  content={errors.auth}
                />
              )}
              <Button
                style={{ marginTop: 22 }}
                className="overwrite-button cta-orange block-button"
                content={"Send a recovery link"}
                disabled={!isValid || !dirty || isSubmitting}
                loading={isSubmitting}
                type={"submit"}
              />
            </Form>
          )}
        </Formik>
      </div>
    </ModalWrapper>
  );
}
